import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { PartnerFilterForm } from "Partner/Components/Form/PartnerFilterForm";
import { Close, FilterList } from "@mui/icons-material";
import { Box, Button, Drawer, Stack, Typography } from "@mui/material";
import { useState } from "react";

const partnerResource = Resources.base.partner.shared;

export const PartnerFilterWidget = () => {
	const { t } = useResource();
	const [isFilterDrawerOpen, setIsFilterDrawerOpen] = useState(false);

	const handleFilterDrawerOpen = () => {
		setIsFilterDrawerOpen(true);
	};

	return (
		<>
			<Button
				title={t(partnerResource.filters)}
				onClick={handleFilterDrawerOpen}
			>
				<FilterList />
			</Button>
			<Drawer
				anchor="right"
				open={isFilterDrawerOpen}
				onClose={() => setIsFilterDrawerOpen(false)}
				PaperProps={{
					sx: {
						p: 4,
						width: {
							xs: "100%",
							sm: "85%",
							md: "40%",
							lg: "35%",
							xl: "25%",
						},
					},
				}}
			>
				<Stack flexDirection="row" justifyContent="space-between">
					<Typography variant="h4">{t(partnerResource.filters)}</Typography>
					<Box
						onClick={() => setIsFilterDrawerOpen(false)}
						sx={{ cursor: "pointer" }}
					>
						<Close />
					</Box>
				</Stack>
				<PartnerFilterForm setIsFilterDrawerOpen={setIsFilterDrawerOpen} />
			</Drawer>
		</>
	);
};
